// Header-v2.1.0.jsx - Version: 2.1.0 - Created: 2024-12-08
import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './Header-v2.1.0.css'

const Header = () => {
  const location = useLocation()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const navigation = [
    { path: '/', label: 'خانه', icon: '🏠' },
    { path: '/academy', label: 'آکادمی', icon: '📚' },
    { path: '/playground', label: 'زمین بازی', icon: '🎮' },
    { path: '/practice', label: 'باشگاه تمرین', icon: '🎯' },
    { path: '/parents', label: 'والدین', icon: '👨‍👩‍👧‍👦' }
  ]

  const handleStartFree = () => {
    // هدایت به صفحه آکادمی برای شروع رایگان
    window.location.href = '/academy'
  }

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false)
  }

  return (
    <header className="header-v2">
      <div className="header-container">
        {/* Logo */}
        <Link to="/" className="logo-section" onClick={closeMobileMenu}>
          <div className="logo">
            <div className="logo-placeholder">♛</div>
            <span className="logo-text">Chess4Kids.ir</span>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          {navigation.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              <span className="nav-icon">{item.icon}</span>
              {item.label}
            </Link>
          ))}
        </nav>

        {/* CTA Button */}
        <div className="header-actions">
          <button 
            className="cta-button primary-button"
            onClick={handleStartFree}
          >
            شروع رایگان
          </button>

          {/* Mobile Menu Button */}
          <button 
            className="mobile-menu-button"
            onClick={toggleMobileMenu}
            aria-label="منوی موبایل"
          >
            {isMobileMenuOpen ? '✕' : '☰'}
          </button>
        </div>

        {/* Mobile Navigation */}
        <div className={`mobile-nav ${isMobileMenuOpen ? 'active' : ''}`}>
          {navigation.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`mobile-nav-link ${location.pathname === item.path ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              <span className="nav-icon">{item.icon}</span>
              {item.label}
            </Link>
          ))}
          <button 
            className="cta-button primary-button mobile-cta"
            onClick={() => {
              handleStartFree()
              closeMobileMenu()
            }}
          >
            شروع رایگان
          </button>
        </div>

        {/* Overlay برای موبایل */}
        {isMobileMenuOpen && (
          <div 
            className="mobile-overlay"
            onClick={closeMobileMenu}
          ></div>
        )}
      </div>
    </header>
  )
}

export default Header